// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e7d722b2","807":"b444e3ac","831":"c8f6d35b"}[chunkId] + ".chunk.js";
};